import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicSlash = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33.74,
	height: 27,
	viewBox: "0 0 33.74 27",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M33.52,26.68a.83.83,0,0,1-.66.32.85.85,0,0,1-.48-.18L.32,1.51A.86.86,0,0,1,.18.32.85.85,0,0,1,1.37.18L33.43,25.49A.8.8,0,0,1,33.52,26.68ZM21.79,26.2A.79.79,0,0,1,21,27H12.61a.87.87,0,0,1-.84-.84.84.84,0,0,1,.84-.85h3.33V21.87A8.63,8.63,0,0,1,8.39,13.2V11.14l1.69,1.33v.79a7,7,0,0,0,6.33,7,6.74,6.74,0,0,0,2.95-.48l1.47,1.16a8.19,8.19,0,0,1-3.11,1v3.43h3.33A.71.71,0,0,1,21.79,26.2Zm-8.38-21V6.53L11.77,5.2V5.06a5.06,5.06,0,0,1,10.12,0V13.2l-1.75-1.39h.06V10.13H18.05l-1.16-.92a.84.84,0,0,1,.83-.77H20.2V6.75l-2.48-.09a.8.8,0,1,1,0-1.6H20.2A3.36,3.36,0,0,0,16.49,1.7a3.49,3.49,0,0,0-3,3.52ZM25.06,15.57,23.57,14.4a4.76,4.76,0,0,0,.1-.9V11a.81.81,0,0,1,.8-.84.84.84,0,0,1,.8.84V13.5A10.68,10.68,0,0,1,25.06,15.57Z",
		fill: "#5b1954"
	})]
});
const ForwardRef = forwardRef(SvgMicSlash);
export default ForwardRef;
